import React, { Component } from "react";
import "./FormToken.css";
import FormTokenSchema from "./FormTokenSchema";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import { TextField } from "formik-material-ui";
import axios from "axios";
import { Formik, Field } from "formik";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import FormDocumentacionUpdate from "../FormDocumentacion/FormDocumentacionUpdate";
import Swal from "sweetalert2";

class FormToken extends Component {
  state = {
    proceso: null,
    dataProceso: null,
    msgError: null,
    iconMsgError: null,
    token: null,
  };

  openModalDocumentacion = () => {
    this.setState({
      openFormDocumentacion: true,
    });
  };

  closeModalDocumentacion = () => {
    Swal.fire({
      title: "CONFIRMAR ACCIÓN",
      text: "Si cierra la venta, No se alojaran sus documentos",
      icon: "info",
      showCancelButton: true,
      cancelButtonText: "CANCELAR",
      confirmButtonText: "CONFIRMAR",
    }).then((result) => {
      if (result.value) {
        window.location.reload(true);
      }
    });
  };

  render() {
    return (
      <Formik
        initialValues={{
          Token: "",
        }}
        validationSchema={FormTokenSchema}
        onSubmit={(values, { setSubmitting }) => {
          var reqToken = {
            Token: values.Token,
          };
          setTimeout(() => {
            axios({
              url: process.env.REACT_APP_DOCUMENTACIONAPI + "searchtoken",
              method: "post",
              data: JSON.stringify(reqToken),
              headers: {
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                if (response.data.Code === 202) {
                  this.setState({
                    msgError: null,
                    dataProceso: response.data,
                    proceso: response.data.Proceso,
                    token: values.Token,
                  });
                  this.openModalDocumentacion();
                } else {
                  let codigo = parseInt(response.data.Code);
                  let icon;
                  if (codigo === 200) {
                    icon = "success";
                  } else {
                    icon = "info";
                  }

                  this.setState({
                    msgError: response.data.Message,
                    iconMsgError: icon,
                    token: values.Token,
                  });
                }
                setSubmitting(false);
              })
              .catch((err) => {
                console.log("err",err)
                if (err.toString() === "Error: Network Error") {
                  this.setState({
                    iconMsgError: "error",
                    msgError:
                      "Existe un problema con el recurso por favor intenta más tarde o comunícate al Contact Center UFG 2209-2834",
                  });
                } else if (err.response.data !== undefined) {
                  this.setState({
                    msgError: err.response.data.Message,
                    iconMsgError: "warning",
                  });
                } else {
                  this.setState({
                    iconMsgError: "error",
                    msgError:
                      "Existe un problema con el recurso por favor intenta más tarde o comunícate al Contact Center UFG 2209-2834",
                  });
                }
                setSubmitting(false);
              });
          });
        }}
      >
        {({ handleSubmit, isSubmitting }) => (
          <div className="height-340">
            <MDBContainer className="wrap-form-token">
              <MDBRow>
                <MDBCol size="12" sm="12" md="12" lg="12" xl="12" className="mt-3">
                  <h3 className="title-token">¿YA TIENES TOKEN?</h3>
                  <h4 className="text-important">
                    Si ya posees tu n&uacute;mero de Token, puedes consultar tu proceso de documentaci&oacute;n aqu&iacute;
                  </h4>
                  <div className="input-token">
                    <Field
                      component={TextField}
                      name="Token"
                      label="Token"
                      autoComplete="off"
                      fullWidth
                      inputProps={{
                        maxLength: 8,
                      }}
                    />
                  </div>
                  <div className="mt-3">
                    {this.state.msgError !== null ? (
                      <MDBCol className="mb-3 col-12">
                        <Alert severity={this.state.iconMsgError} className="text-center">
                          {this.state.msgError}
                        </Alert>
                      </MDBCol>
                    ) : null}
                  </div>
                </MDBCol>
              </MDBRow>
              <form onSubmit={handleSubmit}>
                <MDBRow className="justify-content-center">
                  <MDBCol className="p-4 d-flex justify-content-end">
                    <Button variant="contained" type="submit" disabled={isSubmitting} className="bt-send-form">
                      {isSubmitting ? "CARGANDO" : "CONSULTAR"}
                    </Button>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBContainer>
            <Dialog fullScreen open={this.state.openFormDocumentacion}>
              <AppBar>
                <Toolbar className="center-title-fullmodal">
                  <Typography variant="h6">{this.state.proceso}</Typography>
                  <IconButton edge="start" color="inherit" aria-label="close" onClick={this.closeModalDocumentacion}>
                    <CloseIcon />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <DialogContent className="center-content-fullmodal m-64">
                <FormDocumentacionUpdate
                  respDataFormInicial={this.state.dataProceso}
                  respProceso={this.state.proceso}
                  resToken={this.state.token}
                />
              </DialogContent>
            </Dialog>
          </div>
        )}
      </Formik>
    );
  }
}
export default FormToken;
